import React, { Component } from 'react';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import { MyGlobal, MyAlert } from '../GlobalContext';
import { Link } from 'react-router-dom';
import Resizer from "react-image-file-resizer";
import * as $ from 'jquery';

export class InwardsImageCapture extends Component {
    static displayName = InwardsImageCapture.name;

    constructor(props) {
        super(props);
        this.state = {
            selectedInwards: props.location.state,
            loading: false,
            alertMessage: "",
            containerNo: "",
            selectedInwardsId:"",
            resizedImageUri: "",
            uploadedImage: "",
            fileName: "",
            fileContentType: "",
            fileComments: "",
            category: "General",
            uploadedImages: [], // List to store uploaded images
        };
        this.history = props.history;

    }

    componentDidMount() {
        if (this.state.selectedInwards) {
            this.setState({
                containerNo: this.state.selectedInwards.containerNo,
                selectedInwardsId: this.state.selectedInwards.id

            });
            // Fetch all images associated with the shipment from the server and update the state
            this.fetchExistingImages();
        }
    }
    goto(page) {
        this.history.push(page);
    }
    fetchExistingImages() {
        fetch(`api/Inwards/GetShipmentFilesByShipmentId?shipmentId=${this.state.selectedInwards.inwardsGuid}`)
            .then(response => response.json())
            .then(apiResponse => {
                this.setState({ uploadedImages: apiResponse.data });
            })
            .catch(error => {
                console.error('Error fetching existing images:', error);
            });
    }

    handleFileSelect = (file) => {

    
        const resizeCompletedEvent = (newFileUri, imageMeta) => {
            if (newFileUri) {
               
                this.state.uploadedImage = newFileUri.split(';base64,')[1];
                this.state.fileName = file.name;
                this.state.fileContentType = file.type;
                var sizeInBytes = 4 * Math.ceil((this.state.uploadedImage.length / 3)) * 0.5624896334383812;
                var sizeInKb = sizeInBytes / 1000;
                if (sizeInKb >= 500) {
                    this.setState({ loading: false, alertMessage: "Uploaded image is very large.", uploadedImage: "", resizedImageUri: "" });
                    $("#captureImage").val(null);
                    return;
                }
                else {
                    this.state.resizedImageUri = newFileUri;
                }
            }
            this.setState({ loading: false, alertMessage: "" });

        };

        const resizeImage = (imageFile) => {
            this.setState({ loading: true, alertMessage: "" });
            try {
                Resizer.imageFileResizer(
                    imageFile,
                    200,
                    200,
                    "JPEG",
                    75,
                    0,
                    resizeCompletedEvent,
                );
            } catch (err) {
                console.log(err);
                this.setState({ loading: false, alertMessage: err.message, uploadedImage: "", resizedImageUri: "" });
                $("#captureImage").val(null);
                return;
            }
        };

        const handleImageResize = (event) => resizeImage(file);
        handleImageResize();
    };

    saveInwardsImage() {

        if (!this.state.uploadedImage || !this.state.uploadedImage) {
            this.setState({ alertMessage: "Please capture/upload a picture" });
            return;
        }
        if (!this.state.category) {
            this.setState({ alertMessage: "Please select a image Category" });
            return;
        }

        if (this.state.fileComments && this.state.fileComments.length > 100) {
            this.setState({ alertMessage: "File comments limit exceeded" });
            return;
        }
        if (this.state.fileName && this.state.fileName.length > 200) {
            this.setState({ alertMessage: "File name is too long" });
            return;
        }
        this.setState({ loading: true, alertMessage: "" });
        const addShipmentFileRequest = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                ShipmentID: this.state.selectedInwards.inwardsGuid,
                FileName: this.state.fileName,
                FileData: this.state.uploadedImage,
                FileContentType: this.state.fileContentType,
                FileComments: this.state.fileComments,
                Category: this.state.category
            })
        };
        this.state.loading = true;
        fetch('api/Inwards/AddShipmentFile', addShipmentFileRequest)
            .then(async response => {

                this.setState({ loading: false });
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    this.setState({ alertMessage: "Failed to save shipment image!!" + errorText });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;
                    if (apiResponse) {
                        if (apiResponse.success) {
                            this.setState({ alertMessage: "Image saved successfully!!" });
                            //load added image
                            const updatedUploadedImages = [
                                ...this.state.uploadedImages,
                                {
                                    file_Name: this.state.fileName,
                                    file_Data: this.state.uploadedImage,
                                    file_Content_Type: this.state.fileContentType,
                                    file_Comments: this.state.fileComments,
                                    category: this.state.category
                                },
                            ];

                            this.setState({
                                uploadedImages: updatedUploadedImages,
                            });
                        }
                        else {
                            this.setState({ alertMessage: "Failed to save shipment image!!  " + apiResponse.errorMessage });
                        }
                    }
                    else {
                        this.setState({ alertMessage: "Failed to save shipment image!!" });
                    }
                }
            })
            .catch(error => {
                this.setState({ alertMessage: error });
            });
    }
 
    render() {

        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";

        const existingImagesThumbnails = this.state.uploadedImages.map((image, index) => (
                <img src={`data:${image.file_Content_Type};base64, ${image.file_Data}`}  
                    alt={`Thumbnail ${index}`}
                className="img-thumbnail" style={{ width: '100px', height: '100px', marginRight: '5px' }}
            />

        ));

        return <div className="container" >
            {this.state.loading && <div> <em>Loading ... </em></div>}
            <Container>
                <Row className="mb-3">
                    <Col xs={9}>
                        <h5>Shipment Details</h5>
                    </Col>
                    <Col xs={3}>
                        <Link className="btn btn-success col-12 mb-2" to={{ pathname: "ReceivedShipments" }}>Back</Link>
                    </Col>
                </Row>
                <Row>
                    <Col>{alertMessage}</Col>
                </Row>
                <Row className="mb-3">
                    <Col xs={5}>
                        <label>Shipment Reference :</label>
                    </Col>
                    <Col xs={7}>
                        {this.state.containerNo}
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col xs={5}>
                        <label>Shipment Id :</label>
                    </Col>
                    <Col xs={7}>
                        {this.state.selectedInwardsId}
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col xs={5}>
                        <label>Take a picture</label>
                    </Col>
                    <Col xs={7}>
                        <input type="file" id="captureImage" onChange={e => this.handleFileSelect(e.target.files[0])}
                            name="picture"
                            accept="image/*"
                            capture="environment" />
                    </Col>
                </Row>
                {this.state.uploadedImage && this.state.resizedImageUri && (
                    <Row className="mb-3">
                        <Col xs={5}>
                          
                        </Col>
                        <Col xs={7}>
                            <div><br /><img id="uploadedImage" src={this.state.resizedImageUri} alt="uploaded image" /></div>
                        </Col>
                    </Row>
                )}
                <Row className="mb-3">
                    <Col xs={5}>
                        <label>Category:</label>
                    </Col>
                    <Col xs={7}>
                        <select className="form-select form-control" aria-label=".form-select-lg example" value={this.state.category} onChange={(e) => {
                            this.setState({ category: e.target.value });
                        }} >
                            <option key="0" value="General" defaultValue >General</option>
                            <option key="1" value="Damages" >Damages</option>
                        </select>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col xs={5}>
                        <label>File Comments :</label>
                    </Col>
                    <Col xs={7}>
                        <textarea className="form-control" value={this.state.fileComments} maxLength="100"
                            onChange={(e) => {
                                this.setState({ fileComments: e.target.value });
                            }} ></textarea>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col xs={12}>
                        <button className="btn btn-success col-12 mb-2 mt-1" disabled={this.state.loading} onClick={() => { this.saveInwardsImage() }}> Save </button>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col xs={12}>
                        {existingImagesThumbnails}
                    </Col>
                </Row>
            </Container>

        </div>
    }


}
